// Central content for the Lucky's Kitchen website.
// Contact details below are the client's confirmed business details.
// WhatsApp stays EMPTY until the client confirms a WhatsApp number — set it in Admin → Settings.

export const CONTACT = {
  whatsapp: "",
  phone: "+918938935757",
  phoneDisplay: "+91 89389 35757",
  email: "luckyskitchenbbsr@gmail.com",
  address: "Plot No. 350, Infocity Road, Near Canara Bank, Patia, Bhubaneswar, Odisha",
  hours: "Open daily — timings to be confirmed",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Lucky%27s+Kitchen+Patia+Bhubaneswar",
  locations: [
    { label: "Patia", address: "Plot No. 350, Infocity Road, Near Canara Bank, Patia, Bhubaneswar, Odisha", phone: "+918938935757", email: "luckyskitchenbbsr@gmail.com", maps_url: "" },
    { label: "Puri Bypass · Pandara", address: "Plot No. 148, Bhubaneswar–Puri Bypass, Koradakanta, Pandara, Bhubaneswar, Odisha", phone: "+918938934888", email: "luckyskitchenbbsr@gmail.com", maps_url: "" },
  ],
};

export const fmtPhone = (p = "") => {
  const d = p.replace(/\D/g, "").slice(-10);
  return d.length === 10 ? `+91 ${d.slice(0, 5)} ${d.slice(5)}` : p;
};

export const telHref = (p = "") => `tel:+91${p.replace(/\D/g, "").slice(-10)}`;

export const mapsSearch = (q) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

export const optimizedImageUrl = (src, width = 1400) => {
  if (!src.startsWith("https://images.unsplash.com/")) return src;
  const url = new URL(src);
  url.searchParams.set("auto", "format");
  url.searchParams.set("fit", "crop");
  url.searchParams.set("q", "75");
  url.searchParams.set("w", String(width));
  return url.toString();
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -68 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const NAV_LINKS = [
  { id: "home", label: "Home", to: "/" },
  { id: "about", label: "About", to: "/about" },
  { id: "menu", label: "Menu", to: "/order" },
  { id: "gallery", label: "Gallery", to: "/gallery" },
  { id: "banquet-hall", label: "Banquet Hall", to: "/banquet-hall" },
  { id: "contact", label: "Contact", to: "/contact" },
];

export const DEFAULT_SPECIAL_DISHES = [
  {
    name: "Paneer Tikka Angara",
    description: "Char-grilled cottage cheese with smoked spices and yoghurt.",
    image: "/images/lkvdo2.webp",
    diet_type: "vegetarian",
    display_order: 1,
  },
  {
    name: "Butter Chicken",
    description: "Tender tandoori chicken in a creamy tomato-makhani gravy.",
    image: "/images/lkvdo3.webp",
    diet_type: "non_vegetarian",
    display_order: 2,
  },
  {
    name: "Chicken Dum Biryani",
    description: "Layered basmati rice and chicken, sealed and slow-steamed.",
    image: "/images/lkvdo4.webp",
    diet_type: "non_vegetarian",
    display_order: 3,
  },
  {
    name: "Gulab Jamun",
    description: "Soft khoya dumplings served in warm saffron syrup.",
    image: "/images/luckys-kitchen-fine-dine-bhubaneswar.jpeg",
    diet_type: "vegetarian",
    display_order: 4,
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1728910156510-77488f19b152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmb29kJTIwZmVhc3QlMjBiYW5xdWV0JTIwc3ByZWFkJTIwYmlyeWFuaSUyMGN1cnJ5fGVufDB8fHx8MTc5MTA4MzI1OHww&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1535850452425-140ee4a8dbae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjByZXN0YXVyYW50JTIwYW1iaWVuY2UlMjBjaGVmJTIwZGluaW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkxMDgzMjU4fDA&ixlib=rb-4.1.0&q=85",
  ambience: "https://images.unsplash.com/photo-1673081760594-828ed9f8d0f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjByZXN0YXVyYW50JTIwYW1iaWVuY2UlMjBjaGVmJTIwZGluaW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkxMDgzMjU4fDA&ixlib=rb-4.1.0&q=85",
  specialities: [
    {
      title: "Chef's Special",
      desc: "Signature creations from our kitchen — hand-picked spices, slow-cooked to perfection.",
      url: "https://images.unsplash.com/photo-1697155406055-2db32d47ca07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBmb29kJTIwZmVhc3QlMjBiYW5xdWV0JTIwc3ByZWFkJTIwYmlyeWFuaSUyMGN1cnJ5fGVufDB8fHx8MTc5MTA4MzI1OHww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Family Favourites",
      desc: "Generous platters and thalis made for sharing — the dishes our guests return for.",
      url: "https://images.unsplash.com/photo-1631515242808-497c3fbd3972?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBmb29kJTIwZmVhc3QlMjBiYW5xdWV0JTIwc3ByZWFkJTIwYmlyeWFuaSUyMGN1cnJ5fGVufDB8fHx8MTc5MTA4MzI1OHww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Fresh & Delicious",
      desc: "Crisp starters and vibrant flavours, prepared fresh through the day, every day.",
      url: "https://images.unsplash.com/photo-1601050690597-df0568f70950?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmb29kJTIwc2Ftb3NhJTIwYnV0dGVyJTIwY2hpY2tlbiUyMG5hYW4lMjBkZXNzZXJ0JTIwdGFuZG9vcml8ZW58MHx8fHwxNzkxMDgzMjU4fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Quick & Tasty",
      desc: "Short on time? Quick bites and express meals without compromising on taste.",
      url: "https://images.unsplash.com/photo-1734604638459-cccfd82bc311?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBmb29kJTIwc2Ftb3NhJTIwYnV0dGVyJTIwY2hpY2tlbiUyMG5hYW4lMjBkZXNzZXJ0JTIwdGFuZG9vcml8ZW58MHx8fHwxNzkxMDgzMjU4fDA&ixlib=rb-4.1.0&q=85",
    },
  ],
  gallery: [
    { label: "Banquet Hall Entrance", src: "/images/luckys-kitchen-banquet-hall-bhubaneswar.jpeg" },
    { label: "Birthday Celebration Setup", src: "/images/luckys-kitchen-banquet-hall-birthday-point-bhubaneswar.jpeg" },
    { label: "Floral Entrance", src: "/images/luckys-kitchen-banquet-hall-entrance-bhubaneswar.jpeg" },
    { label: "Grand Floral Walkway", src: "/images/luckys-kitchen-banquet-hall-entrance-closeup-bhubaneswar.jpeg" },
    { label: "Open-Air Dining Lawn", src: "/images/luckys-kitchen-banquet-hall-lawn-bhubaneswar.jpeg" },
    { label: "Banquet Stage", src: "/images/luckys-kitchen-banquet-hall-stage-bhubaneswar.jpeg" },
    { label: "Stage Galleria", src: "/images/luckys-kitchen-banquet-hall-stage-galleria-bhubaneswar.jpeg" },
    { label: "Fine Dining Interior", src: "/images/luckys-kitchen-fine-dine-bhubaneswar.jpeg" },
  ],
};

export const MENU = [
  {
    id: "starters",
    label: "Starters",
    items: [
      { name: "Paneer Tikka Angara", desc: "Char-grilled cottage cheese marinated in smoked spices and yoghurt.", price: 240, veg: true, pick: true },
      { name: "Chicken 65", desc: "Crisp-fried chicken tossed with curry leaves and red chillies.", price: 260, spicy: true },
      { name: "Crispy Corn Kernels", desc: "Golden fried corn with a pepper-garlic crunch.", price: 180, veg: true },
      { name: "Veg Manchurian", desc: "Vegetable dumplings glazed in a garlic-soy sauce.", price: 190, veg: true },
      { name: "Tandoori Wings", desc: "Smoky chicken wings straight from the clay oven.", price: 280, spicy: true },
    ],
  },
  {
    id: "main-course",
    label: "Main Course",
    items: [
      { name: "Butter Chicken", desc: "Creamy tomato-makhani gravy with tender tandoori chicken.", price: 320, pick: true },
      { name: "Paneer Butter Masala", desc: "Silky makhani gravy with soft, fresh paneer.", price: 280, veg: true },
      { name: "Dal Tadka Fry", desc: "Slow-cooked lentils finished with a ghee tempering.", price: 220, veg: true },
      { name: "Kadai Chicken", desc: "Rustic chicken with roasted kadai masala and peppers.", price: 300, spicy: true },
      { name: "Malai Kofta", desc: "Melt-in-mouth dumplings in a rich cashew gravy.", price: 260, veg: true },
    ],
  },
  {
    id: "rice-and-biryani",
    label: "Rice & Biryani",
    items: [
      { name: "Chicken Dum Biryani", desc: "Layered basmati and chicken, sealed and slow-steamed.", price: 280, pick: true },
      { name: "Mutton Biryani", desc: "Tender mutton cooked with saffron and fried onions.", price: 340 },
      { name: "Veg Dum Biryani", desc: "Garden vegetables and basmati, served with mint raita.", price: 220, veg: true },
      { name: "Jeera Rice", desc: "Basmati tossed with ghee-roasted cumin.", price: 150, veg: true },
      { name: "Egg Fried Rice", desc: "Smoky wok-tossed rice with egg and spring onion.", price: 180 },
    ],
  },
  {
    id: "chinese",
    label: "Chinese",
    items: [
      { name: "Hakka Noodles", desc: "Wok-tossed noodles with crisp seasonal vegetables.", price: 190, veg: true },
      { name: "Chilli Chicken", desc: "Fiery chicken in a garlic-chilli glaze.", price: 270, spicy: true },
      { name: "Gobi Manchuria", desc: "Crispy cauliflower in a tangy manchurian sauce.", price: 180, veg: true },
      { name: "Chicken Schezwan Noodles", desc: "Noodles tossed in our house schezwan sauce.", price: 260, spicy: true },
      { name: "Veg Fried Rice", desc: "Classic wok rice with spring onion and beans.", price: 170, veg: true },
    ],
  },
  {
    id: "beverages",
    label: "Beverages",
    items: [
      { name: "Masala Chai", desc: "Spiced milk tea brewed the traditional way.", price: 40, veg: true },
      { name: "Sweet Punjabi Lassi", desc: "Thick churned yoghurt, lightly sweetened.", price: 80, veg: true },
      { name: "Fresh Lime Soda", desc: "Chilled lime, soda and a hint of black salt.", price: 60, veg: true },
      { name: "Cold Coffee", desc: "Blended cold coffee with a creamy froth.", price: 90, veg: true },
      { name: "Mango Shake", desc: "Seasonal mangoes blended with chilled milk.", price: 110, veg: true, pick: true },
    ],
  },
  {
    id: "desserts",
    label: "Desserts",
    items: [
      { name: "Gulab Jamun (4 pc)", desc: "Soft khoya dumplings in warm saffron syrup.", price: 90, veg: true, pick: true },
      { name: "Rasmalai", desc: "Delicate cheese discs soaked in saffron milk.", price: 110, veg: true },
      { name: "Gajar ka Halwa", desc: "Slow-cooked carrot halwa with ghee and nuts.", price: 120, veg: true },
      { name: "Kulfi Falooda", desc: "Traditional kulfi over vermicelli and rose syrup.", price: 130, veg: true },
      { name: "Ice Cream Scoops", desc: "Ask our team for today's flavours.", price: 80, veg: true },
    ],
  },
];

export const TESTIMONIALS = [
  { name: "Priya S.", text: "Delicious food and a lovely atmosphere. The biryani is an absolute must-try." },
  { name: "Rahul M.", text: "Great place for a family meal. Warm service and generous portions." },
  { name: "Ananya K.", text: "Fresh food and friendly service, every single time we visit." },
];
